// TableComponent.js
import { Backdrop, CircularProgress, Tooltip } from '@mui/material';
import { DateTime } from 'luxon';
import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import checkmark from '../../assets/checkmark.png'
import summarizedpng from '../../assets/summarized.png'
import useModalStore from 'zustand/zustandstore';
import AudioModal from 'basic/modals/audiomodal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMicrophone, faPlay, faRecordVinyl } from '@fortawesome/free-solid-svg-icons';
import api from 'api/api';
import BasicPdfRender from 'basic/basicutils/basicpdfrender';
import pdf from '../../assets/pdf.png'
import TextModal from 'basic/basicutils/notesmodal';
import ModalPortal from './modalportal';

const TableComponent = ({ title, data, mydata,toggleSidebar,loading,setLoading,setSidebarOpen, selectedRecord,  formatDate }) => {
 const navigate=useNavigate()
   const [audioSrc, setAudioSrc] = useState(null);
    //  const [loading,setLoading]=useState(false)
  const [isModalOpen, setIsModalOpen] = useState(false);
    const[mycard,setMyCard]=useState('')
      const [ispdfshow,setIspdfShow]=useState(false)
      const[savednotes,setsavedNotes]=useState('')
      const[textModal,setTextModal]=useState(false)
        const [pdffile,setPdffile]=useState()
 const location = useLocation();
   const { setModalValue } = useModalStore()
    const renderStatus = (item) => {
      // const isSelected =  selectedRecord?.patientid === item.patientid;

      const isSelected = mydata.usertype === 'BUSINESS' 
      ? selectedRecord?.id === item.id 
      : selectedRecord?.patientid === item.patientid;
   
     if (item.transcriptionstatus === null || item.transcriptionstatus === "") {
       return <div className={`rounded-full px-2 py-1 text-xs font-medium ${isSelected?" bg-[#DBEAFE] text-[#166534]":"text-[#797070] border shadow-[0px_0px_1px_0px_rgba(0,0,0,0.25)] bg-[#F7F7F7] "}`}>Ready</div>;
     } else if (item.transcriptionstatus === "Submitted") {
       return <div className='rounded-full px-2 py-1 text-sm font-medium bg-[#FEF9C3] text-[#854D0E] '>{"20%"}</div>
   
     } else if (item.transcriptionstatus === "Processing") {
       const recording_duration = item?.recording_duration || 200; // Fallback to a default value
       const totalProcessingTime = Math.max((420 / 1287) * recording_duration, 60);
     let ts="2025-05-12T18:43:34" //8:38 pro
     let ts1='2025-05-12T20:42:10' //8:42  plus
     const recordingStartTime = DateTime.fromISO(item?.ts).toSeconds();
 
   
   // Current time in UTC, rounded to whole seconds
   const currentTime = Math.floor(DateTime.now().toSeconds()); // or you can use Math.round() if you prefer rounding
 
      
       const elapsedSinceStart = Math.max(currentTime - recordingStartTime, 0);
 
       // Calculate the initial percentage based on the elapsed time
       const completionPercentage = Math.min(
         Math.round(20 + (70 * elapsedSinceStart) / totalProcessingTime),
         90
       );
 
   
   
   
   
   
   return <div className='rounded-full px-2 py-1 text-sm font-medium bg-[#FEF9C3] text-[#854D0E]'>{completionPercentage+"%"}</div>
   
     } else if (item.transcriptionstatus === "Summarized") {
     
       return (
         <div className="ml-2" onClick={(e)=>{
            e.stopPropagation();
            setModalValue({selectedRecord :item})  
            setModalValue({ screen :1}) 
            if (!location.pathname.startsWith('/v2')) {
              navigate('/v2');
            }
            setSidebarOpen(false)
          
         }}>
           <Tooltip title="Pending Review">
             {/* <img src={summarizedpng} alt="pending review" className="w-6 h-6" /> */}
             <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 25 31" fill="none">
  <path d="M7.87484 17.0423C7.87484 18.2689 8.36211 19.4453 9.22947 20.3127C10.0968 21.18 11.2732 21.6673 12.4998 21.6673C13.7265 21.6673 14.9029 21.18 15.7702 20.3127C16.6376 19.4453 17.1248 18.2689 17.1248 17.0423C17.1248 15.8157 16.6376 14.6393 15.7702 13.7719C14.9029 12.9046 13.7265 12.4173 12.4998 12.4173C11.2732 12.4173 10.0968 12.9046 9.22947 13.7719C8.36211 14.6393 7.87484 15.8157 7.87484 17.0423ZM24.8332 27.2019V9.33398L15.5832 0.0839844H3.24984C2.43209 0.0839844 1.64783 0.408835 1.06959 0.987072C0.491354 1.56531 0.166504 2.34957 0.166504 3.16732V27.834C0.166504 28.6517 0.491354 29.436 1.06959 30.0142C1.64783 30.5925 2.43209 30.9173 3.24984 30.9173H21.7498C22.4436 30.9173 23.0603 30.6861 23.5844 30.3007L16.7548 23.4711C15.5215 24.2727 14.0415 24.7507 12.4998 24.7507C10.4555 24.7507 8.49481 23.9385 7.04922 22.4929C5.60363 21.0473 4.7915 19.0867 4.7915 17.0423C4.7915 14.9979 5.60363 13.0373 7.04922 11.5917C8.49481 10.1461 10.4555 9.33398 12.4998 9.33398C14.5442 9.33399 16.5049 10.1461 17.9505 11.5917C19.396 13.0373 20.2082 14.9979 20.2082 17.0423C20.2082 18.584 19.7303 20.064 18.9286 21.2819L24.8332 27.2019Z" fill="#DE8276"/>
</svg>
           </Tooltip>
         </div>
       );
     } else if (item.transcriptionstatus === "APPROVED") {
       return (
         <div className="ml-2">
           <Tooltip title="Completed">
             {/* <img src={checkmark} alt="Completed" className="w-6 h-6" /> */}
             <div 
              onClick={(e)=>{
                e.stopPropagation();
                setModalValue({selectedRecord :item})  
                setModalValue({ screen :1}) 
                if (!location.pathname.startsWith('/v2')) {
                  navigate('/v2');
                }
              
             }}
             className={`rounded-full px-2 py-1 text-xs font-medium bg-[#DBEAFE] text-[#1E40AF]`}>Signed Off</div>
           </Tooltip>
         </div>
       );
     } else {
       return null;
     }
   }
   const handlepdf = async (value,card) => {



    try {
      // Trigger loading spinner
      setLoading(true);

      const uniqueParam = new Date().getTime(); // or use a random number: Math.random()

    // Fetch the PDF from the server with a unique parameter to prevent caching
    const response = await api.get(`/v1/basic/documents/PDF/${value}?_=${uniqueParam}`, {
      responseType: "blob", // Ensure response type is 'blob' for binary data
    });
       const pdfBlob = new Blob([response], { type: "application/pdf" });

      // Generate a URL for the Blob
      const pdfUrl = URL.createObjectURL(pdfBlob);
      setMyCard(card)
      setPdffile(pdfBlob)
      // Open the generated URL in a new tab
      //window.open(pdfUrl, "_blank");

    } catch (error) {
      console.error("Error fetching the PDF:", error);
    } finally {
      // Turn off loading spinner
setLoading(false)
      setIspdfShow(true)
    }
  };
   const handleCloseModal = () => {
    setIsModalOpen(false);
    setAudioSrc(null); // Reset audio source when modal closes
  };
  const handleplay=async(audio_link)=>{
    try {
      setLoading(true)
      const response = await api.get(`/v1/audio/${audio_link}`, {
        responseType: "blob", // Make sure response is treated as a Blob
      });
      const fileBlob = response;
      const audioURL = URL.createObjectURL(fileBlob);
          setAudioSrc(audioURL);
          if(fileBlob&&fileBlob.size==0){
         setAudioSrc('')
         alert('')
          }
        setIsModalOpen(true)
    } catch (error) {
      console.log(error)
    }finally{
  setLoading(false)
    }
   }
 
    return (<>{
    data.length > 0 && (
      <div>
        <h2 className="w-full   text-start text-[#6B7280] font-semibold mb-2">{title}</h2>
        {data.map((item, index) => {
          // const isSelected =  selectedRecord?.patientid === item.patientid;
          const isSelected = mydata.usertype === 'BUSINESS' 
          ? selectedRecord?.id === item.id 
          : selectedRecord?.patientid === item.patientid;
          return (
            <div
              key={index}
              className={`w-full px-3 relative py-2 cursor-pointer rounded-[4px] border   flex justify-between overflow-auto items-center mb-2 
                ${isSelected ? "bg-[#FFF] border-2 border-[#A2C6FD]" : "bg-[#F7F7F7] "}`}
                style={{ boxShadow: '0px 1px 3px 0px rgba(0, 0, 0, 0.10), 0px 1px 2px -1px rgba(0, 0, 0, 0.10)' }}
              onClick={(e) => {
                e.stopPropagation()
                const timestamp = new Date().getTime();
                const profilePhotoUrl = null;
                if(mydata.usertype==='PRO'||true){  ///bypassed if condition 
                  setModalValue({selectedRecord :item})                   
                              
                 
                  if(item.transcriptionstatus==='Summarized'){
                    setModalValue({selectedRecord :item})  
                    setModalValue({ screen :1}) 
                    if (!location.pathname.startsWith('/v2')) {
                      navigate('/v2');
                    }
                  }else{
                    setModalValue({ screen :0}) 
                  }
                    if (location.pathname.startsWith('/archive')) {
                    navigate(`/archive/${item.patientid}`, {
                      state: { ts: timestamp, profile_photo: profilePhotoUrl },
                    })


                  }else if (location.pathname.startsWith('/basic-archive')) {
                    const targetId = mydata.usertype === 'BUSINESS' ? item?.id : item?.patientid;
                    navigate(`/basic-archive/${targetId}`, {
                      state: { ts: timestamp, profile_photo: profilePhotoUrl },
                    });


                  }
setSidebarOpen(false)
                  return
                }
             
                
              }}
            >
              <div className="flex flex-col">
                <span className={`${isSelected?'text-black':'text-[#797070]'} font-medium text-start`}>
                  {mydata.usertype === 'BUSINESS' ? item.name : item.patient_name}
                  <div className="text-gray-500">
                    ({mydata.usertype === 'BUSINESS' ?  item?.notes ? (
    item.notes.length > 10 ? (
      <>
        {item.notes.slice(0, 10)}...{" "}
        <span
          className="text-blue-500 text-sm cursor-pointer"
          onClick={(event) => {
            event.stopPropagation(); // Prevent event propagation
            setsavedNotes(item.notes);
            setTextModal(true);
          }}
        >
          View More
        </span>
      </>
    ) : (
      item.notes
    )
  ) : (
    <span className="text-gray-500 italic"></span>
  )
                    
                    
                    : item.patientid})
                  </div>
                </span>
                <span className="text-gray-500 text-sm text-start">{mydata.usertype === 'PRO' ?  new Date(item.startdate).toLocaleTimeString("en-US", {
                      hour: "numeric",
                      minute: "numeric",
                      hour12: true,
                    }): formatDate(new Date(item.ts))}</span>
               
              </div>
             
              <div
               className='w-auto flex items-center gap-4 '
            
              >
                  {(((mydata.usertype==='BUSINESS')&&item.transcriptionstatus === "Summarized"||(item.transcriptionstatus === "APPROVED"))&&(item.transcriptionstatus !== "Processing"))?<Tooltip title="View Pdf"><img
                            onClick={(e) => {
                              e.stopPropagation();
                              handlepdf(item.audiolink.split(".")[0], item);
                            }}
                            src={pdf}
                            alt="PDF"
                            className="w-6 h-6 cursor-pointer"
                          /></Tooltip>:<div className="w-6 h-6"></div>}
                 {mydata.usertype==='BUSINESS'?<> <div 
                        onClick={(e)=>{
                          e.stopPropagation()
                          handleplay(item.audiolink);
                
                        }}
                        className="cursor-pointer">
                            <FontAwesomeIcon icon={faPlay} className="text-[#94A3B8] w-5 h-5 "/>
                        </div></>:<></>}
                {renderStatus(item)}
           
              </div>
              {mydata.usertype==='PRO'&&item.status=='recording'?<div className='absolute top-0 right-2 text-red-500 '>
                <FontAwesomeIcon icon={faMicrophone} />
                      </div>:<></>}
            </div>
          );
        })}
     
      </div>
    )}
         {/* <Backdrop
            sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={loading}
          >
            <CircularProgress color="inherit" />
          </Backdrop> */}
                {/* <BasicPdfRender ispdfshow={ispdfshow}setIspdfShow={setIspdfShow} pdfBlob={pdffile} data={mycard}/>
    <AudioModal
            open={isModalOpen}
            onClose={handleCloseModal}
            audioSrc={audioSrc}
            loading={loading}
          />
              <TextModal isOpen={textModal} setTextModal={setTextModal} notes={savednotes}/> */}
              <ModalPortal
  isAudioOpen={isModalOpen}
  audioSrc={audioSrc}
  onAudioClose={handleCloseModal}
  loading={loading}

  isPdfOpen={ispdfshow}
  onPdfClose={setIspdfShow}
  pdfBlob={pdffile}
  pdfData={mycard}

  isTextOpen={textModal}
  onTextClose={setTextModal}
  notes={savednotes}
/>

  </>);
};

export default TableComponent;